<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="360px"
    @keydown.esc="closeDialog"
  >
    <v-card id="excelCreate">
      <div>
        <div class="dialog-header" style="justify-content: center;">
          엑셀업로드
        </div>
        <img
          class="excel-closeBtn"
          src="../../../src/images/button/btnClose.png"
          @click="close()"
        />
        <div class="btnArea">
          <button class="excel-uploadBtn" @click="$refs.uploadBtn.click()">
            <img src="../../../src/images/button/excel.png" alt="엑셀 업로드" />
            <div>엑셀 업로드</div>
            <input
              type="file"
              ref="uploadBtn"
              id="styled-checkbox-3"
              style="display:none;"
              @change="uploadExcel($event.target.name, $event.target.files)"
            />
            <label for="styled-checkbox-3"></label>
          </button>
          <a href="/static/webex-cloud/form/attendees_form.xlsx" download>
            <!-- <a href="/static/webex-cloud/form/서울시 영상회의 사용자등록.zip"></a> -->
            <button
              class="excel-downloadBtn"
              href="/static/webex-cloud/form/attendees_form.zip"
              download
            >
              <img
                src="../../../src/images/button/down.png"
                alt="엑셀 양식 다운로드"
              />
              <div>양식 다운로드</div>
            </button>
          </a>
        </div>
      </div>
      <!-- <div class="layer_popWrap" style="display:block;">
          <div class="bg"></div>
          <div class="inner" style="top:30%;width:400px; margin-left:-200px;">
            <div class="popHeader">
              <h1 class="pop_tit">엑셀업로드<span class="titline"></span></h1>
              <a @click="close" class="pop_close">x</a>
            </div>
            <div class="popContainer" style="min-height:100px;">
              <div class="excel_up">
                <div class="btnline">
                  <a href="/static/webex-cloud/form/attendees_form.xlsx" download>양식다운로드</a>
                </div>
                <div class="btn_com">
                  <a @click="$refs.uploadBtn.click()">엑셀업로드</a>
                  <input type="file" ref="uploadBtn" style="display:none;"
                    @change="uploadExcel($event.target.name, $event.target.files)" />
                </div>
              </div>
              <div class="btn_crud" style="margin-top:40px">
                <a class="btn_linedf small" @click="close">확인</a>
              </div>
            </div>
          </div>
        </div> -->
    </v-card>
  </v-dialog>
</template>
<script>
import Util from "@/util";
import debounce from "lodash.debounce";
import excel from "exceljs";

export default {
  components: {},
  props: ["dialog", "closeDialog"],
  data() {
    return {
      loading: true,
      error: null,
    };
  },
  methods: {
    init() {
      this.error = null;
      this.selectedBookmarkList = null;
    },
    close() {
      this.init();
      this.closeDialog();
    },
    async uploadExcel(name, files) {
      if (this.$refs.uploadBtn.value === "") {
        return;
      }
      if (!files.length) return;
      let file = files[0];
      this.loading = true;
      let reader = new FileReader();
      reader.onload = e => {
        this.importAttendeesProc(e.target.result);
        this.$refs.uploadBtn.value = "";
      };
      reader.readAsArrayBuffer(file);
    },
    async importAttendeesProc(attendeeData) {
      let workbook = new excel.Workbook();
      let arrayBuffer = attendeeData;
      let importAttendees = [];
      await workbook.xlsx.load(arrayBuffer).then(async function(workbook) {
        // 첫번째 sheet 가져오기
        let sheet = workbook.worksheets[0];
        console.log(`?? : `,sheet)
        sheet.eachRow(function(row, rowNumber) {
          if (rowNumber >= 4) {
            console.log(row.values[2]);
            importAttendees.push({
              email:
                typeof row.values[1] === "object"
                  ? row.values[1]["text"]
                  : row.values[1],
              name:
                typeof row.values[2] === "object"
                  ? row.values[2]["text"]
                  : row.values[2],
            });
          }
        });
      });
      if (importAttendees.length < 1) {
        Util.snackBarOpen("No data rows", "error");
        this.loading = false;
        return;
      }

      let duplicateList = Util.isDuplicate(importAttendees);
      if (duplicateList.length > 0) {
        let listString = "";
        duplicateList.forEach(element => {
          listString += "[" + element.email + "]  ";
        });

        alert("엑셀 내 중복되는 email이 있습니다. \n" + listString);
        // if (duplicateList[0].email !== undefined) {
        // }
      } else {
        this.closeDialog(importAttendees);
      }
      // 조직도 데이터와 매핑 ( 없는 사용자는 추가 )
      // let body = {
      //   emails: importAttendees
      // };
      // await this.$http.post('/api/v1/organizations/check/user/info', body).then(async response => {
      //   if (response.data) {
      //     this.addAttendees(response.data);
      //     this.loading = false;
      //   }
      // }).catch(error => {
      //   console.log(error);
      //   Util.snackBarOpen(`An error occurred during processing.`, 'error');
      //   this.loading = false;
      // });
    },
  },
};
</script>
<style scoped>
#excelCreate {
  box-shadow: 0px 36px 48px 0px #0000003d;
  border-radius: 20px;
  height: 250px;
}

.dialog-header {
  background-color: white;
  color: #1f2e3d;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  height: 65px;
  line-height: 88px;
}

.excel-uploadBtn {
  width: 146px;
  height: 118px;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  gap: 10px;
  padding: 30px, 0px, 28px, 0px;
  border-radius: 4px;
  font-size: 14px;
  background-color: #f9f9f9;
}
.excel-downloadBtn {
  width: 146px;
  height: 118px;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  gap: 10px;
  background-color: #f9f9f9;
  padding: 30px, 0px, 28px, 0px;
  font-size: 14px;
  color: #292929;
  border-radius: 4px;
  background: #f9f9f9;
}

.btnArea {
  justify-content: center;
}
.btnArea a {
  text-decoration: none;
  color: #292929;
}

.btnArea button {
  margin: 5px;
}
.excel-closeBtn {
  position: absolute;
  top: 20px;
  right: 30px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/ExcelCreateDialog.vue